__turbopack_context__.v({
  "image": "Promotion-module-scss-module__KP0QTW__image",
  "imageContainer": "Promotion-module-scss-module__KP0QTW__imageContainer",
  "imageWrapper": "Promotion-module-scss-module__KP0QTW__imageWrapper",
  "label": "Promotion-module-scss-module__KP0QTW__label",
  "line": "Promotion-module-scss-module__KP0QTW__line",
  "promotion": "Promotion-module-scss-module__KP0QTW__promotion",
});
